export const numTrialDays = 14;
